export default "__VITE_ASSET__70649f8c__"